<template>
  <div>
    <div class="lib__field">
      <div class="lib__tile__picture lib__text-secondary">
        <img :src="require('@/assets/e-mobility/Icon-battery.svg')" alt="icon-battery">
      </div>
      <div class="lib__text-center">
        <h2 class="lib__h2">{{$t('e-mobility.car-specification-step.carModel.capacityFormat', {brand: brand, model: model})}}</h2>
        <h1 class="lib__h1 no-transform">{{batteryCapacity}} kWh
          <div class="lib__tooltips">
            <span @click="onBatteryCapacityTooltipClick">
              <i class="fas fa-info-circle lib__clickable-tooltips"></i>
            </span>
          </div>
        </h1>
      </div>
    </div>
    <ModalDialog :closeable="$t('common.close')" :open.sync="isBatteryCapacityModalOpen" size="default">
      <p v-html="$t('e-mobility.car-specification-step.carModel.capacityModal')"></p>
    </ModalDialog>
  </div>
</template>

<script lang="ts">
import { ElectricVehicle } from '@/models'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component({
  name: 'electric-vehicle-selected-form'
})
export default class ElectricVehicleSelectedForm extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly value!: ElectricVehicle | null
  //#endregion

  //#region [Data]
  public isBatteryCapacityModalOpen: boolean = false

  @State('requestId', { namespace: 'eMobility' })
  public requestId!: string
  //#endregion

  //#region [Computed]
  public get brand(): string {
    return this.value?.brand ?? ''
  }

  public get model(): string {
    return this.value?.model ?? ''
  }

  public get batteryCapacity(): string {
    return this.value?.batteryTotalCapacity?.toString() ?? ''
  }
  //#endregion

  //#region [Method]
  public onBatteryCapacityTooltipClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'Capacite de batterie'
    })
    this.isBatteryCapacityModalOpen = !this.isBatteryCapacityModalOpen
  }
  //#endregion
}
</script>

<style scoped>
.no-transform {
  text-transform: none;
}
</style>